import { render, staticRenderFns } from "./EntityHeader.vue?vue&type=template&id=44b5cbad&"
import script from "./EntityHeader.vue?vue&type=script&lang=js&"
export * from "./EntityHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44b5cbad')) {
      api.createRecord('44b5cbad', component.options)
    } else {
      api.reload('44b5cbad', component.options)
    }
    module.hot.accept("./EntityHeader.vue?vue&type=template&id=44b5cbad&", function () {
      api.rerender('44b5cbad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/atoms/EntityHeader.vue"
export default component.exports